import { Component, ReactNode } from 'react';
import { Translation } from 'react-i18next';
import { format } from 'date-fns';
import { getUserName } from '@features/authentication/authFunctions';


interface ErrorBoundaryAppProps {
	children: ReactNode
}

interface ErrorBoundaryAppState {
	hasError: boolean,
	errorMessage: string | undefined,
	errorStack: string | undefined
}


class ErrorBoundaryApp extends Component<ErrorBoundaryAppProps, ErrorBoundaryAppState> {
	constructor(props: ErrorBoundaryAppProps) {
		super(props);
		this.state = {
			hasError: false,
			errorMessage: undefined,
			errorStack: undefined
		};
	}

	static getDerivedStateFromError(error: Error) {
		return { hasError: true, errorMessage: error.message, errorStack: error.stack };
	}

	override componentDidCatch(error: Error, errorInfo: any) {
		console.error('Error boundary Error');
		console.error(`Details:\nError Info: ${errorInfo}\nError: ${error}\nEnvironment: ${process.env.ENV}`);
	}

	override render() {
		if (this.state.hasError) {
			return (
				<Translation ns='global'>{( t ) => 
					<div className='lfmt-error-boundary error-boundary-app'>
						<h1>{t('errorBoundary.header1')}</h1>
						<h3>{t('errorBoundary.header2')}</h3>

						<p className='error-label'>
							{t('errorBoundary.appLabel')}:</p>
						<p>{t('errorBoundary.appName')}</p>

						<p className='error-label'>
							{t('errorBoundary.time')}:</p>
						<p>{format(new Date(), 'dd.MM.yyyy HH:mm')}</p>

						<p className='error-label'>
							{t('errorBoundary.user')}:</p>
						<p>{getUserName()}</p>

						<p className='error-label'>
							{t('errorBoundary.message')}:</p>
						<p>{this.state.errorMessage}</p>

						<p className='error-label'>
							{t('errorBoundary.stackTrace')}:</p>
						<p>{this.state.errorStack}</p>
					</div>
				}</Translation>
			);
		};
		return this.props.children;
	}
}

export default ErrorBoundaryApp;